<template>
  <div class="mobile-floating">
    <!-- 플로팅 버튼들 -->
    <div class="floating-buttons">
      <!-- 방문예약 버튼 -->
      <button class="floating-btn bounce-1" @click="$emit('open-form')">
        <img 
          v-if="visitImage"
          :src="visitImage" 
          alt="방문예약"
        />
        <div v-else class="fallback-content visit">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"/>
          </svg>
          <span>방문예약</span>
        </div>
      </button>
      
      <!-- 전화상담 버튼 -->
      <a href="tel:1600-9768" class="floating-btn bounce-2">
        <img 
          v-if="callImage"
          :src="callImage" 
          alt="전화상담"
        />
        <div v-else class="fallback-content call">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
          </svg>
          <span>전화상담</span>
        </div>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MobileFloating',
  emits: ['open-form'],
  data() {
    return {
      visitImage: null,
      callImage: null
    }
  },
  created() {
    // assets 폴더에서 이미지 로드
    try {
      this.visitImage = require('@/assets/mobile/floating-visit.png')
    } catch (e) {
      console.log('floating-visit.png not found')
    }
    
    try {
      this.callImage = require('@/assets/mobile/floating-call.png')
    } catch (e) {
      console.log('floating-call.png not found')
    }
  }
}
</script>

<style scoped>
.mobile-floating {
  position: fixed;
  bottom: 85px;
  right: 8px;
  z-index: 990;
}

.floating-buttons {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.floating-btn {
  width: 110px;
  height: 110px;
  border: none;
  padding: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  overflow: hidden;
  background: transparent;
}

.floating-btn:active {
  transform: scale(0.95);
}

.floating-btn img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

/* 바운스 애니메이션 */
.bounce-1 {
  animation: bounce1 2s ease-in-out infinite;
}

.bounce-2 {
  animation: bounce2 2s ease-in-out infinite;
  animation-delay: 0.3s;
}

@keyframes bounce1 {
  0%, 100% { 
    transform: translateY(0); 
  }
  50% { 
    transform: translateY(-8px); 
  }
}

@keyframes bounce2 {
  0%, 100% { 
    transform: translateY(0); 
  }
  50% { 
    transform: translateY(-8px); 
  }
}

/* 이미지 없을 때 폴백 스타일 */
.fallback-content {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 5px;
  color: #fff;
}

.fallback-content.visit {
  background: linear-gradient(135deg, var(--main-color1) 0%, var(--main-color2) 100%);
  box-shadow: 0 6px 20px rgba(0, 171, 205, 0.5);
}

.fallback-content.call {
  background: linear-gradient(135deg, #ff6b35 0%, #e63946 100%);
  box-shadow: 0 6px 20px rgba(230, 57, 70, 0.5);
}

.fallback-content svg {
  width: 35px;
  height: 35px;
}

.fallback-content span {
  font-size: 14px;
  font-weight: 700;
  text-align: center;
  line-height: 1.2;
}
</style>